import React from "react";
import { useRef, useCallback } from "react";
import {competencyHeaders}  from "./data/competency-headers.js" 


import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
} from "chart.js";
import { Radar } from "react-chartjs-2";


const plugin = {
  id: "customCanvasBackgroundColor",
  beforeDraw: (chart, args, options) => {
    const { ctx } = chart;
    ctx.save();
    ctx.globalCompositeOperation = "destination-over";
    ctx.fillStyle = options.color || "#fff";
    ctx.fillRect(0, 0, chart.width, chart.height);
    ctx.restore();
  },
};

ChartJS.register(
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
  plugin
);


const options = {
  plugins: [plugin],
  scales: {
    r: {
      pointLabels: {
        callback: function (label, index) {
          if (label === `A1.1 ${competencyHeaders["A1.1"]}`) {
            return "A1.1 Rättsliga och...";
          } else if (label === `B2.1 ${competencyHeaders["B2.1"]}`) {
            return "B2.1 Utvecklings- och...";
          } else {
            return label;
          }
        },
      },
      ticks: {
        font: {
          size: 16,
          weight: "bold",
        },
      },
    },
  },
  scale: {
    min: 0,
    max: 3,
    ticks: {
      beginAtZero: true,
      max: 3,
      min: 0,
      stepSize: 1,
    },
  },
};

export function RadarElement({ values }) {

  const data = {
    labels: Object.keys(competencyHeaders).map(key => `${key} ${competencyHeaders[key]}`)
  }
console.log(data.labels)

  let ref = useRef(null);

  const downloadImage = useCallback(() => {
    const link = document.createElement("a");
    link.download = "kompetenskarta.jpeg";
    link.href = ref.current.toBase64Image("image/jpeg", 1);
    link.click();
  }, []);
  if (!values.present.includes(null)) {
    data.datasets = [
      {
        label: "Nuvarande kompetensnivå",
        data: values.present,
        backgroundColor: "rgba(255, 99, 132, 0.2)",
        borderColor: "rgba(255, 99, 132, 1)",
        borderWidth: 1,
      },
    ];
  }
  if (!values.goal.includes(null)) {
    data.datasets = [
      ...data.datasets,
      {
        label: "Mål",
        data: values.goal,
        backgroundColor: "rgba(54, 162, 235, 0.2)",
        borderColor: "rgb(54, 162, 235)",
        pointBackgroundColor: "rgb(54, 162, 235)",
        borderWidth: 1,
      },
    ];
  }

  return (
    <div>
      <p className="content-area">
      Ladda ner en bild på din kompetenskarta&nbsp; 
        <button type="button" className="link-button" onClick={downloadImage}>
        här
        </button>
        .
      </p>
      <Radar ref={ref} data={data} options={options} />
    </div>
  );
}
